// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

export interface PropertyEntry {
  id: string;
  key: string;
  value: string;
}

export function propertyEntriesFromMap(values: Record<string, string>): PropertyEntry[] {
  return Object.entries(values).map(([key, value]) => ({
    id: crypto.randomUUID(),
    key: key.trim(),
    value,
  }));
}

export function propertyEntriesToMap(properties: PropertyEntry[]): Record<string, string> {
  return properties.reduce<Record<string, string>>((acc, { key, value }) => {
    if (key !== '') acc[key] = value;
    return acc;
  }, {});
}

export function getPropertyErrors(properties: PropertyEntry[]): string[] {
  const seenKeys = new Set<string>();

  return properties.map(({ key }) => {
    if (key === '') return 'Property name is required';
    if (seenKeys.has(key)) return 'Duplicate property name';
    seenKeys.add(key);
    return '';
  });
}
